/**
 * root store
 */
import Vue from 'vue';
import md5 from 'md5';
import * as types from './mutation-types';
import * as urls from '../config/urls';
import * as helpers from '../utils/helpers';
import auth from '../utils/auth';
import $ from 'jquery'
const UPDATE_MENU_SELECTED = 'UPDATE_MENU_SELECTED';
const LOGINOUT = 'LOGINOUT';
import axios from 'axios';
axios.defaults.withCredentials = false;
export default {
    state: {
        // 全局loading状态
        isLoading: false,
        // 用户信息
        userInfo: auth.getUserInfo(),
        menuSelected: 'DataManage',
    },

    // getters: {
    //     // 通过键名访问userInfo的值
    //     getUserInfo: state => (key) => {
    //         const { [key]: value } = state.userInfo || {};
    //         return value || '';
    //     },
    // },

    mutations: {
        [types.UPDATE_LOADING_STATUS](state, yes) {
            state.isLoading = yes;
        },
        [types.UPDATE_USER_INFO](state, payload) {
            state.userInfo = payload;
        },
        [UPDATE_MENU_SELECTED](state, selected) {
            state.menuSelected = selected;
        },
        [LOGINOUT](state, data) {
            console.log('清除');
            state.userInfo = data;
        },
    },

    actions: {
        // 更新loading
        startLoading({ commit }) {
            commit(types.UPDATE_LOADING_STATUS, true);
        },

        // 更新loading
        stopLoading({ commit }) {
            commit(types.UPDATE_LOADING_STATUS, false);
        },

        // // 请求密码登录
        requestPasswordLogin({ commit }, formData = {}) {
            const reqData = helpers.pick(formData, [
                'username',
                'password',
            ]);
            const password = md5(reqData.password);
            return new Promise((resolve, reject) => {
                axios.post(urls.GET_SELF_USERINFO, {
                    'username': reqData.username,
                    'password': password

                }).then((response) => {
                    console.log(response.data);

                    if (response.data) {
                        if (response.data.result) {

                            console.log(response.data.data);
                            auth.saveToken(response.data.data);
                            auth.saveUserInfo(response.data.data);
                            commit(types.UPDATE_USER_INFO, response.data.data);

                            resolve(response);
                        } else {

                            this.message.error('登录失败：账号密码错误');
                        }

                    } else {

                        this.message.error('登录失败：账号密码错误');
                        return;
                    }
                }).catch((error) => {
                    reject(error);
                });
            });

            // //  认证服务认证
            // return new Promise((resolve1, reject) => {
            //     axios.post(urls.GET_AUTH, {
            //         'username': reqData.username,
            //         'password': password

            //     }).then((response1) => {

            //         console.log(response1.data.token);
            //         axios.post(urls.GET_USERINFO, {
            //             token: response1.data.token,
            //         }).then((response) => {


            //             console.log(response.data);
            //             if (response.data) {
            //                 if (response.data) {
            //                     console.log(response.data.data);
            //                     auth.saveToken(response.data.data);
            //                     auth.saveUserInfo(response.data.data);
            //                     commit(types.UPDATE_USER_INFO, response.data.data);

            //                     resolve2(response);
            //                 } else {

            //                     deubgger
            //                     this.message.error('登录失败：账号密码错误');
            //                 }

            //             } else {
            //                 this.message.error('登录失败：账号密码错误');
            //                 return;
            //             }


            //         }).catch((error) => {
            //             reject(error);
            //         });

            //     }).catch((error) => {
            //         reject(error);
            //     });
            // });
        },

        ssorequestPasswordLogin({ commit }, formData = {}) {
            const reqData = helpers.pick(formData, [
                'token',
            ]);
            debugger

            return new Promise((resolve, reject) => {
                axios.post(urls.GET_SELF_SSO_USERINFO, {
                    'token': reqData.token,

                }).then((response) => {
                    console.log(response.data);

                    if (response.data) {
                        if (response.data.result) {

                            console.log(response.data.data);
                            auth.saveToken(response.data.data);
                            auth.saveUserInfo(response.data.data);
                            commit(types.UPDATE_USER_INFO, response.data.data);

                            resolve(response);
                        } else {

                            this.message.error('登录失败：账号密码错误');
                        }

                    } else {

                        this.message.error('登录失败：账号密码错误');
                        return;
                    }
                }).catch((error) => {
                    reject(error);
                });
            });
        },

        updateMenuSelected({ commit }, selected) {
            commit(UPDATE_MENU_SELECTED, selected);
        },
        loginOut({ commit }, data) {
            console.log('清除');
            commit(LOGINOUT, data);
        },
    },
};